/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var PageableCollection = require('psa-backbone/models/PageableCollection');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');
var bodybuilder = require('bodybuilder');

var ElasticSearchSummaryView = require('common/views/ElasticSearchSummaryView');
var GridView = require('psa-marionette/views/GridView');

var SelectOneCell = require('common/backgrid/SelectOneCell');
var AddressCell = require('common/backgrid/AddressCell');

var SearchConSerEntities = require('../../common/services/SearchConSerEntities');

var tmplConSerEntitySearchModalView = require('../templates/ConSerEntitySearchModalView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplConSerEntitySearchModalView,

  className: 'con-ser-entity-search-modal-view',

  ui: {
    searchResultsGrid: '.search-result-grid-container',
    search: '.btn-search',
    searchSummary: '.search-summary',
    formInputs: ':input',
    submit: '.btn-submit'
  },

  regions: {
    searchSummary: '@ui.searchSummary',
    searchResultsGrid: '@ui.searchResultsGrid'
  },

  events: {
    'click @ui.search': 'onClickSearchEntities',
    'click @ui.submit': 'onClickSubmit',
    'keydown @ui.formInputs': 'onKeydownOfInputs'
  },  

  onClickSubmit: function(e) {
    e.preventDefault();
    var selectedModel = this.searchResultsGrid.viewGrid.getSelectedModel();

    if (selectedModel) {
      this.triggerMethod('modal:close', selectedModel.toJSON());
    } else {
      this.triggerMethod('modal:close');
    }
  },

  onBeforeShow: function() {
    this.searchSummaryView = new ElasticSearchSummaryView({
      model: new Backbone.Model({
        searchLimit: this.model.get('searchLimit')
      })
    });
    this.showChildView('searchSummary', this.searchSummaryView);

    this.searchResultsGrid = new GridView({
      columns: [
        {
          name: 'selected',
          label: '',
          cell: SelectOneCell.SelectOneRowCell,
          headerCell: SelectOneCell.SelectOneHeaderCell,
          width: 10,
          editable: true,
          sortable: false
        },
        {
          name: 'entityName',
          label: 'Entity Name',
          cell: 'string',
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'dba',
          label: 'D/B/A',
          cell: 'string',
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'email',
          label: 'Email',
          cell: 'string',
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'phone',
          label: 'Phone',
          cell: 'string',
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'fax',
          label: 'Fax',
          cell: 'string',
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'address',
          label: 'Street Address',
          cell: AddressCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
      ],
      collection: new PageableCollection([], { pageSize: 10 }),
      emptyText: 'No Entities Found'
    });

    this.showChildView('searchResultsGrid', this.searchResultsGrid);

  },

  onKeydownOfInputs: function(e) {
    // Searches on press of enter
    if (e.keyCode === 13) {
      this.onClickSearchEntities(e);
    }
  },

  onClickSearchEntities: function(e) {
    e.preventDefault();
    var self = this;

    var data = Syphon.serialize(this, {
      inputReaders: Syphon.SearchInputReaderSet
    });

    // If no inputs were given, do not perform a search.
    if (!data.addressLine1 && !data.city && !data.entityName && !data.dba) {
      return;
    }
    this.searchSummaryView.reset();

    var laddaContext = Ladda.create(this.ui.search[0]);
    laddaContext.start();
    var body = bodybuilder();

    if (data.entityName) {
      body.query('bool', function(b) {
        b.orQuery('match', 'entityName', {
          query: data.entityName,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'entityName', data.entityName.toLowerCase() + '*');
        b.orQuery('match', 'entityName.phonetic', data.entityName);
        return b;
      });
    }

    if (data.dba) {
      body.query('bool', function(b) {
        b.orQuery('match', 'dba', {
          query: data.dba,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'dba', data.dba.toLowerCase() + '*');
        b.orQuery('match', 'dba.phonetic', data.dba);
        return b;
      });
    }

    if (data.addressLine1) {
      body.query('bool', function(b) {
        b.orQuery('match', 'address.addressLine1', {
          query: data.addressLine1,
          fuzziness: 'AUTO'
        });
        b.orQuery('wildcard', 'address.addressLine1', data.addressLine1.toLowerCase() + '*');
        return b;
      });
    }

    if (data.city) {
      body.query('bool', function(b) {
        b.orQuery('match', 'address.city', {
          query: data.city,
          fuzziness: 'AUTO'
        });
        b.orQuery('wildcard', 'address.city', data.city.toLowerCase() + '*');
        return b;
      });
    }

    body.size(this.model.get('searchLimit'));
    // Keep for testing
    // console.log(JSON.stringify(bodyObj, null, 2));
    SearchConSerEntities(body.build())
      .done(function(data) {
        laddaContext.stop();
        self.searchResultsGrid.collection.fullCollection.reset(data.hits);
        self.searchSummaryView.display(data);
      })
      .fail(function(err) {
        laddaContext.stop();
      });
  },
});